import { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

// Lazy load pages for performance
const Landing = lazy(() => import('./layouts/landing-page/Landing'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const Docs = lazy(() => import('./pages/Docs'));
const Chatbots = lazy(() => import('./pages/Chatbots'));
const Vision = lazy(() => import('./pages/Vision'));
const ContentStudio = lazy(() => import('./pages/ContentStudio'));
const AssistantPage = lazy(() => import('./pages/AssistantPage'));

// Simple loading fallback
const PageLoader = () => (
    <div style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#000',
        color: '#4CB5E6'
    }}>
        Loading...
    </div>
);

export default function App() {
    return (
        <BrowserRouter>
            <Suspense fallback={<PageLoader />}>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/docs" element={<Docs />} />
                    <Route path="/chatbots" element={<Chatbots />} />
                    <Route path="/vision" element={<Vision />} />
                    <Route path="/assistant" element={<AssistantPage />} />
                    <Route path="/content-studio" element={<ContentStudio />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </Suspense>
        </BrowserRouter>
    );
}
